import { type CommonTranslationKeys } from '@/types/translation';

export const VERIFICATION_ERROR_MESSAGES: Record<
  string,
  CommonTranslationKeys
> = {
  INVALID_SMS_CODE: 'phoneVerify.error.codeInvalid',
  SMS_CODE_EXPIRED: 'phoneVerify.error.codeExpired',
  ANONYMOUS_USER: 'phoneVerify.error.anonymousUser',
};

export const SEND_ERROR_MESSAGES: Record<string, CommonTranslationKeys> = {
  PHONE_SEND_LIMIT_EXCEEDED: 'phoneVerify.error.sendCodeLimitExceeded',
  SMS_SEND_FAILED: 'phoneVerify.error.sendCodeFailed',
  INVALID_PHONE_FORMAT: 'phoneVerify.error.invalidPhoneFormat',
  INVALID_PHONE_NUMBER: 'phoneVerify.error.invalidPhoneNumber',
  PHONE_NUMBER_ALREADY_EXISTS: 'phoneVerify.error.phoneNumberAlreadyExists',
  PHONE_RESEND_COOLDOWN_NOT_EXPIRED:
    'phoneVerify.error.phoneNumberResendCooldownNotExpired',
  ANONYMOUS_USER: 'phoneVerify.error.anonymousUser',
  PHONE_VERIFICATION_NOT_ALLOWED:
    'phoneVerify.error.phoneVerificationNotAllowed',
};
